import { render, staticRenderFns } from "./HelpMain.vue?vue&type=template&id=a23194de&"
import script from "./HelpMain.vue?vue&type=script&lang=js&"
export * from "./HelpMain.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports